export default {

  names: [
    'mapDiffuse',
    'mapDiffusePreview',
    'mapDiffuseSource',
    // specular
    'mapSpecular',
    'mapSpecularPreview',
    'mapSpecularSource',
    // normal
    'mapNormal',
    'mapNormalPreview',
    'mapNormalSource',
    // alpha
    'mapAlpha',
    'mapAlphaPreview',
    'mapAlphaSource',
    // lightmap
    'mapLight',
    'mapLightPreview',
    'mapLightSource'
  ],

  nameToType: {
    // diffuse
    mapDiffuse: 'diffuse',
    mapDiffusePreview: 'diffuse',
    mapDiffuseSource: 'diffuse',
    // specular
    mapSpecular: 'specular',
    mapSpecularPreview: 'specular',
    mapSpecularSource: 'specular',
    // normal
    mapNormal: 'normal',
    mapNormalPreview: 'normal',
    mapNormalSource: 'normal',
    // alpha
    mapAlpha: 'alpha',
    mapAlphaPreview: 'alpha',
    mapAlphaSource: 'alpha',
    // light
    mapLight: 'light',
    mapLightPreview: 'light',
    mapLightSource: 'light',
  },

  nameToFormat: {
    // loRes
    mapDiffusePreview: 'loRes',
    mapSpecularPreview: 'loRes',
    mapNormalPreview: 'loRes',
    mapAlphaPreview: 'loRes',
    mapLightPreview: 'loRes',
    // source
    mapDiffuseSource: 'source',
    mapSpecularSource: 'source',
    mapNormalSource: 'source',
    mapAlphaSource: 'source',
    mapLightSource: 'source',
    // dds
    mapDiffuse: 'dds',
    mapSpecular: 'dds',
    mapNormal: 'dds',
    mapAlpha: 'dds',
    mapLight: 'dds'
  }

}